/** Mirrors actionlabs-services OutboundMailAttachments limits. */
export const EMAIL_ATTACHMENT_MAX_FILES = 5
export const EMAIL_ATTACHMENT_MAX_BYTES = 3 * 1024 * 1024

const ALLOWED_EXTENSIONS = new Set([
  'pdf',
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'txt',
  'csv',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'zip',
])

export function isEmptyHtml(html: string): boolean {
  const text = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  return text === ''
}

function extensionOf(name: string): string {
  const parts = name.toLowerCase().split('.')
  return parts.length > 1 ? (parts.pop() ?? '') : ''
}

export function validateEmailAttachment(file: File): string | null {
  if (file.size > EMAIL_ATTACHMENT_MAX_BYTES) {
    return `"${file.name}" exceeds the 3 MB limit.`
  }
  const ext = extensionOf(file.name)
  if (!ALLOWED_EXTENSIONS.has(ext)) {
    return `"${file.name}" is not an allowed file type.`
  }
  return null
}

export function mergeEmailAttachments(current: File[], incoming: FileList | File[]): { files: File[]; error: string | null } {
  const next = [...current]
  for (const file of Array.from(incoming)) {
    if (next.length >= EMAIL_ATTACHMENT_MAX_FILES) {
      return { files: next, error: `You can attach up to ${EMAIL_ATTACHMENT_MAX_FILES} files.` }
    }
    const problem = validateEmailAttachment(file)
    if (problem) {
      return { files: next, error: problem }
    }
    const duplicate = next.some((existing) => existing.name === file.name && existing.size === file.size)
    if (duplicate) continue
    next.push(file)
  }
  return { files: next, error: null }
}

export function appendEmailFormFields(
  form: FormData,
  fields: { body: string; cc?: string; to?: string; subject?: string; reply_all?: boolean },
  attachments: File[]
): FormData {
  form.append('body', fields.body)
  if (fields.cc?.trim()) form.append('cc', fields.cc.trim())
  if (fields.to?.trim()) form.append('to', fields.to.trim())
  if (fields.subject?.trim()) form.append('subject', fields.subject.trim())
  if (typeof fields.reply_all === 'boolean') {
    form.append('reply_all', fields.reply_all ? '1' : '0')
  }
  for (const file of attachments) {
    form.append('attachments[]', file)
  }
  return form
}
